import {
  IAnswerMap,
  IAnswerValue,
  IDraftAnswer,
  IQuestion,
  ISuggestedAddress,
} from "../types";

/** The only `ai_value` that is an object: every other one is an answer value. */
export const isSuggestedAddress = (
  aiValue: IAnswerValue | ISuggestedAddress | undefined
): aiValue is ISuggestedAddress =>
  typeof aiValue === "object" && aiValue !== null && !Array.isArray(aiValue);

/**
 * The address of the client's last task, which the backend puts on the draft
 * as the `ai_value` of the address answer when it creates it.
 */
export const findSuggestedAddress = (
  answers: IDraftAnswer[] = []
): ISuggestedAddress | undefined =>
  answers.map((answer) => answer.ai_value).find(isSuggestedAddress);

/** Only into a field never filled: `""` is a client who cleared it. */
export const suggestedAddressValues = (
  questions: IQuestion[],
  values: IAnswerMap,
  suggestedAddress: ISuggestedAddress | undefined
): IAnswerMap => {
  const addressQuestion = questions.find(
    (question) => question.type === "address"
  );

  if (
    !addressQuestion ||
    !suggestedAddress ||
    values[addressQuestion.key] != null
  )
    return {};

  return {
    [addressQuestion.key]: suggestedAddress.formatted_address,
    latitude: suggestedAddress.latitude,
    longitude: suggestedAddress.longitude,
    zip_code: suggestedAddress.postal_code,
  };
};
